export const Polygon = ({ h, w }: { h: number; w: number }) => {
  return (
    <svg
      width={h}
      height={w}
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.5 0L20.4593 17.25H0.540708L10.5 0Z" fill="#D9D9D9" />
    </svg>
  );
};
